<template>
	<div class="paging">
		<p class="totalNumber">共{{total}}篇文章</p>
		<p class="onePage" @click="changeCur(1)">首页</p>
		<p class="prev" @click="changeCur(nowCur-1==0?nowCur:nowCur-1)">上一页</p>

		<ul class="pageList">
			<li v-for="(item,index) in num" :key="index" :class="{pageActive:item==nowCur}" @click="changeCur(item)">{{item}}</li>
		</ul>

		<p class="next" @click="changeCur(nowCur==pages?nowCur:nowCur+1)">下一页</p>
		<p class="lastPage" @click="changeCur(pages)">尾页</p>
	</div>
</template>

<script>
	export default {
		props: {
			total: {
				required: false,
				type:Number,
			},
			cur: {
				required: true,
				type:Number
			},
		},
		created() {
			this.pages = Math.ceil(this.total/this.pageSize);
		},
		data() {
			return {
				num: [],	//需要循环的页码
				nowCur: 1,	//当前页码
				pages:1,	//总页数
				pageSize:10,	//默认每页10条  
			}
		},
		methods:{
			changeCur(cur){
				if(cur==this.nowCur)return;
				this.nowCur = cur;
				this.$emit('changePage',cur);
				window.scrollTo(0, 0);
			}
		},
		watch:{
			total(val){
				this.pages = Math.ceil(this.total/this.pageSize);
				this.num = [];
				for (let i = 0; i < this.pages; i++) {
					this.num.push(i + 1);
				}
			}
		}
	}
</script>

<style scoped>
	.paging {
		width: 100%;
		margin: auto;
		overflow: hidden;
		padding: 20px;
		box-sizing: border-box;
	}

	.totalNumber,
	.onePage,
	.lastPage,
	.prev,
	.next {
		float: left;
		color: #666;
		margin: 0 5px 10px;
		padding: 5px 10px;
		background: #F7F7F7;
		cursor: pointer;
	}

	.totalNumber {
		cursor: default;
	}

	.onePage:hover,
	.lastPage:hover,
	.prev:hover,
	.next:hover {
		background-color: #1C2327;
		color: #FFFFFF;
	}

	.pageList {
		float: left;
		color: #666;
	}

	.pageList>li {
		float: left;
		margin: 0 5px;
		background: #F7F7F7;
		padding: 5px 10px;
		cursor: pointer;
	}

	.pageList>li:hover {
		background-color: #1C2327;
		color: #FFFFFF;
	}

	.pageActive {
		background-color: #1C2327 !important;
		color: #FFFFFF;
	}
</style>
